// src/router/AppRouter.tsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import DashboardPage from "../pages/DashboardPage";
import UserPage from "../pages/UserPage";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/LoginPage";
import AcetylenePage from "../pages/AcetylenePage";
import CatalogoPage from "../pages/CatalogoPage";
import FormularioSucursal from "../components/Sucursales/SucursalesForm";
import SucursalIndex from "../components/Sucursales/SucursalIndex";
import TipoEnvaseIndex from "../components/Envases/TipoEnvaseIndex";
import FormularioEdicionSucursal from "../components/Sucursales/SucursalesEdicionForm";
import UserProfile from "../components/UserData/UserProfile";
import AuditTrail from "../components/Auditrail/Auditrail";
import RegistrosList from "../components/RegistrosHistoricos/RegistrosList";
import InternoDataMigrationRoute from "./InternoDataMigrationRoute";

const AppRouter: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route element={<AppLayout />}>
        <Route path="/inicio" element={<DashboardPage />} />
        <Route path="/usuarios" element={<UserPage />} />
        <Route path="/usuario-profile" element={<UserProfile />} />
        <Route path="/auditrail" element={<AuditTrail />} />
        <Route path="/reporte-acetileno" element={<AcetylenePage />} />
        <Route path="/reporte-historico" element={<RegistrosList />} />
        <Route path="/catalogos" element={<CatalogoPage />} />
        <Route path="/catalogos/sucursales-index" element={<SucursalIndex />} />
        <Route path="/catalogos/sucursales-añadir" element={<FormularioSucursal />} />
        <Route path="/catalogos/tipo-envase-index" element={<TipoEnvaseIndex />} />
        <Route path="/catalogos/sucursales/editar/:id" element={<FormularioEdicionSucursal />} />
        <Route path="/interno/migracion-datos" element={<InternoDataMigrationRoute />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default AppRouter;
